import { render, staticRenderFns } from "./SpamThresholdScore.vue?vue&type=template&id=05b0d354&"
import script from "./SpamThresholdScore.vue?vue&type=script&lang=js&"
export * from "./SpamThresholdScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b0d354')) {
      api.createRecord('05b0d354', component.options)
    } else {
      api.reload('05b0d354', component.options)
    }
    module.hot.accept("./SpamThresholdScore.vue?vue&type=template&id=05b0d354&", function () {
      api.rerender('05b0d354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/SpamFilters/SpamThresholdScore.vue"
export default component.exports